
class GiftBox extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    console.log('giftBox init', this);
    this.qtyInput = this.querySelector('.QuantitySelector__CurrentQuantity');
    this.qtyIncrease = this.querySelector('[data-action="increase-quantity"]');
    this.qtyDecrease = this.querySelector('[data-action="decrease-quantity"]');
    this.addToCartBtn = this.querySelector('[data-action="add-to-cart"]');

    this.addToCartBtn.removeEventListener('click', this.addToCart);
    this.qtyIncrease.removeEventListener('click', this.increaseQuantity);
    this.qtyDecrease.removeEventListener('click', this.decreaseQuantity);

    this.addToCartBtn.addEventListener('click', this.addToCart.bind(this));
    this.qtyIncrease.addEventListener('click', this.increaseQuantity.bind(this));
    this.qtyDecrease.addEventListener('click', this.decreaseQuantity.bind(this));
  }

  addToCart() {
    var quantity = this.qtyInput.value || 1;
    var jsonData = JSON.parse(this.querySelector('[data-gift-box-data]').innerHTML);
    var currentVariant = jsonData.currentVariant;

    this.addToCartBtn.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    var items = [{
      id: currentVariant.id,
      quantity: quantity
    }];
    fetch(window.theme.localeRootUrl + '/cart/add.js', {
      body: JSON.stringify({
        'items': items
      }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function (response) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      if (response.ok) {
        this.addToCartBtn.removeAttribute('disabled');
               document.dispatchEvent(new CustomEvent('cart:refresh'));

      } else {
        response.json().then(function (content) {
          var errorMessageElement = document.createElement('span');
          errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
          errorMessageElement.innerHTML = content['description'];
          this.addToCartBtn.removeAttribute('disabled');
          this.addToCartBtn.insertAdjacentElement('afterend', errorMessageElement);
          setTimeout(function () {
            errorMessageElement.remove();
          }, 5000);
        }.bind(this));
      }
    }.bind(this));
  }

  increaseQuantity() {
    console.log('incr');
    this.qtyInput.value = parseInt(this.qtyInput.value) + 1;
  }

  decreaseQuantity() {
    console.log('decr');
    if (parseInt(this.qtyInput.value) <= 1) {
      return;
    }
    this.qtyInput.value = parseInt(this.qtyInput.value) - 1;
  }
}
customElements.define('gift-box', GiftBox);


class GiftMessage extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    console.log('giftMessage init', this);
    this.saveButton = this.querySelector('.GiftMessage__Save');
    this.deleteButton = this.querySelector('.GiftMessage__Delete');
    this.editButton = this.querySelector('.GiftMessage__Edit');
    this.editor = this.querySelector('.GiftMessage__Editor');
    this.checkBox = this.querySelector('.GiftMessage__AddCheckbox');
    this.textArea = this.querySelector('.GiftMessage__TextArea');

    this.saveButton?.addEventListener('click', this.saveMessage.bind(this));
    this.deleteButton?.addEventListener('click', this.deleteMessage.bind(this));
    this.editButton?.addEventListener('click', this.toggleEditor.bind(this));
    this.checkBox?.addEventListener('change', this.toggleEditor.bind(this));
  }

  saveMessage() {
    var jsonData = JSON.parse(this.querySelector('[data-gift-message-data]').innerHTML);
    var line_item = jsonData.line_item;
    var properties = line_item.properties || {};

    this.saveButton.setAttribute('disabled', 'disabled');
    var _this = this;
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    if (this.textArea.value) {
      properties['Gift Message'] = this.textArea.value;
    }
    else if (properties['Gift Message']) {
      delete properties['Gift Message'];
    }
    fetch(window.theme.localeRootUrl + '/cart/change.js', {
      body: JSON.stringify({ id: line_item.key, quantity: line_item.quantity, properties: properties }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function (cart) {
      cart.json().then(function (content) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        _this.saveButton.removeAttribute('disabled');
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
      });
    });
  }

  deleteMessage() {
    this.textArea.value = '';
    this.saveButton.click();
  }

  toggleEditor(event) {
    console.log('toggle editor', event);
    if (this.editor.style.display == 'none') {
      this.editor.style.display = 'block';
    }
    else {
      this.editor.style.display = 'none';
    }
  }
}

customElements.define('gift-message', GiftMessage);


